<template>
  <div
    class="flex h-screen min-h-screen w-screen items-center justify-center bg-gradient-to-bl from-light-cyan
      via-white to-light-cyan py-4"
  >
    <div
      class="container mx-auto flex flex-col items-center justify-center p-5 text-gray-700 md:flex-row"
      data-cy="404Container"
    >
      <div class="max-w-md pr-10 text-center md:text-left">
        <h1 class="text-lg font-bold md:text-4xl">Inhalt nicht mehr verfügbar</h1>
        <p class="font-semi-bold mt-6 text-xl leading-normal md:text-lg">
          Leider konnten der Inhalt dieser Seite nicht mehr gefunden werden. Möglicherweise wurde
          die Anfrage zwischenzeitlich entfernt oder die URL ist fehlerhaft.
        </p>
        <p class="font-semi-bold mt-6 text-xl leading-normal md:text-lg">
          Bitte wenden Sie sich direkt an Ihre Kanzlei, um weitere Informationen zu erhalten.
        </p>
        <p class="mb-8"></p>
      </div>
      <div class="mt-10 max-w-lg md:mt-0">
        <!-- Ensure the SVG scales nicely on smaller screens -->
        <svg
          width="100%"
          height="auto"
          viewBox="0 0 960 960"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_46_7743)">
            <g clip-path="url(#clip1_46_7743)">
              <path
                d="M601.3 114.554C621.306 114.196 642.276 109.387 661.139 115.918C656.909 130.399 641.491 138.376 627.01 142.606C614.387 146.296 601.353 148.397 588.21 148.861C576.977 149.277 565.73 148.502 554.66 146.547C538.802 143.722 523.411 138.514 507.443 136.489C491.475 134.464 474.182 136.061 461.217 145.582C443.25 158.768 438.207 182.976 434.501 204.952C433.688 209.775 432.875 214.583 432.062 219.405L431.484 219.305C425.047 223.58 419.459 229.014 415.005 235.329C412.387 239.035 409.645 243.417 405.168 244.175C401.186 244.85 397.162 242.067 395.568 238.346C393.984 234.64 394.493 230.3 396.05 226.58C397.607 222.86 400.129 219.622 402.609 216.439L402.375 216.191C398.175 220.173 393.968 224.146 389.754 228.109C387.66 230.093 385.124 232.215 382.254 231.802C378.824 231.302 376.954 227.159 377.554 223.742C378.154 220.325 380.475 217.5 382.583 214.742C391.568 203.005 398.412 189.775 402.8 175.66C407.567 160.26 409.33 144.011 414.828 128.869C420.326 113.727 430.648 99.04 446 94.162C458.552 90.162 472.082 93.322 485.2 94.41C502.379 95.73 519.644 93.4702 535.904 87.7735C552.164 82.0768 567.065 73.0673 579.663 61.315C584.031 57.182 589.638 52.332 595.274 54.426C601.598 56.768 601.901 66.041 598.443 71.842C594.984 77.628 589.184 81.789 586.043 87.755L586.057 87.81C598.595 83.6767 611.138 79.5433 623.685 75.41C626.24 74.3974 628.957 73.8554 631.704 73.81C634.446 73.948 637.298 75.298 638.428 77.792C639.792 80.768 638.345 84.254 636.678 87.078C628.807 100.248 616.113 109.834 601.291 113.8L601.3 114.554Z"
                fill="#171717"
              />
              <path
                d="M383.734 321.226C394.164 322.686 404.539 324.312 414.834 326.034C449.155 331.766 483.339 338.228 517.453 345.021C541.29 349.733 565.084 354.61 588.893 359.488L442.793 433.683L191.859 402.558L192.176 577.293L192.259 577.637C191.278 577.869 190.349 578.28 189.517 578.85C186.817 580.71 185.246 583.768 183.771 586.689C171.471 611.077 172.487 607.453 147.218 629.512C139.764 645.233 134.28 662.345 135.038 679.719C135.727 695.261 142.038 711.065 153.776 721.054L153.721 721.123C130.174 730.244 102.467 717.554 87.3935 697.3C72.3195 677.046 67.4294 651.061 65.2114 625.916C59.9754 566.449 67.6355 505.054 93.4115 451.209C119.187 397.364 164.024 351.648 219.881 330.595C271.69 311.085 328.387 313.524 383.734 321.226Z"
                fill="url(#paint0_linear_46_7743)"
              />
              <path
                d="M515.522 324.133C520.675 328.859 522.714 337.733 517.891 342.803L517.45 345.021C483.336 338.228 449.15 331.766 414.831 326.034C404.539 324.312 394.164 322.686 383.731 321.226C381.678 312.146 389.407 302.997 398.363 300.226C404.863 298.214 411.714 298.642 418.493 299.771C421.262 300.24 424.004 300.819 426.718 301.397C446.738 305.682 466.749 309.972 486.75 314.266C489.95 314.941 493.157 315.63 496.35 316.319C503.176 317.781 510.368 319.421 515.522 324.133Z"
                fill="url(#paint1_linear_46_7743)"
              />
              <path
                d="M859.714 620.46C856.231 620.989 852.707 621.188 849.188 621.052C843.029 620.818 836.071 619.068 833.188 613.626C829.454 606.557 834.759 598.167 840.394 592.49C850.279 582.56 861.94 574.573 874.771 568.943C878.015 567.507 881.369 566.332 884.801 565.43C892.71 563.39 901.569 563.03 907.232 568.612C911.889 573.2 911.269 578.326 908.913 583.312C907.227 586.56 905.288 589.67 903.113 592.612C893.016 607.205 877.226 617.842 859.714 620.46Z"
                stroke="#171717"
                stroke-width="4.133"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M860.953 620.942L859.92 621.81C854.739 626.122 849.338 629.746 846.472 635.891C843.414 642.45 843.672 651.13 849.035 655.98C852.879 659.452 858.129 660.141 863.435 659.631C865.975 659.371 868.491 658.911 870.958 658.253C882.174 655.373 893.169 650.923 902.248 643.703C905.942 640.796 909.232 637.409 912.031 633.632C916.224 628.129 919.043 621.705 920.256 614.893C922.156 603.457 918.369 590.864 909.399 583.534"
                stroke="#171717"
                stroke-width="4.133"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M863.626 659.479C863.565 659.534 863.501 659.585 863.433 659.631C856.854 664.842 851.207 671.131 846.733 678.231C844.556 681.648 842.545 685.52 842.999 689.543C843.606 694.889 848.566 698.912 853.815 700.097C859.064 701.282 864.507 700.18 869.729 698.897C870.404 698.731 871.093 698.552 871.768 698.373C881.234 695.92 890.575 692.655 898.787 687.364C907.577 681.688 915.031 673.448 918.187 663.473C921.343 653.498 919.661 641.717 912.565 634.029"
                stroke="#171717"
                stroke-width="4.133"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M147.219 629.512C172.488 607.453 171.469 611.077 183.772 586.689C185.247 583.768 186.817 580.71 189.518 578.85C190.349 578.28 191.279 577.869 192.26 577.637C193.343 577.316 194.495 577.303 195.585 577.6C196.675 577.897 197.661 578.492 198.432 579.318C200.032 581.261 199.92 584.03 199.732 586.538C197.362 616.409 196.783 614.549 191.699 644.075"
                stroke="#171717"
                stroke-width="4.133"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M192.26 644.1C205.473 645.919 218.686 647.743 231.899 649.57C241.93 650.948 252.277 652.449 260.889 657.754C263.699 659.49 266.389 661.754 267.612 664.822C268.835 667.89 268.191 671.89 265.436 673.722C263.465 675.031 260.944 674.989 258.574 674.907L238.706 674.246C222.998 673.722 207.282 673.194 191.557 672.661"
                stroke="#171717"
                stroke-width="4.133"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M238.706 674.387C245.365 675.507 251.551 678.548 256.506 683.136C260.97 687.104 263.437 694.007 260.506 699.215C257.323 704.878 249.731 706.008 243.228 705.98C241.12 705.98 239.012 705.912 236.904 705.801C220.563 704.975 204.456 701.301 188.474 697.631"
                stroke="#171717"
                stroke-width="4.133"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M236.886 706.256C242.563 709.301 248.418 712.484 252.386 717.556C256.354 722.628 257.952 730.163 254.411 735.55C250.291 741.819 241.511 742.65 234.033 742.233C218.918 741.42 204.033 738.265 189.24 735.123C186.03 734.434 182.806 733.746 179.609 732.946C172.031 731.073 164.619 728.606 158.143 724.335C156.621 723.332 155.163 722.237 153.775 721.056C142.036 711.067 135.726 695.263 135.037 679.721C134.279 662.347 139.763 645.235 147.217 629.514"
                stroke="#171717"
                stroke-width="4.133"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M153.721 721.123C130.174 730.244 102.467 717.554 87.3935 697.3C72.3195 677.046 67.4294 651.061 65.2114 625.916C59.9754 566.449 67.6355 505.054 93.4115 451.209C119.187 397.364 164.024 351.648 219.881 330.595C271.687 311.085 328.381 313.524 383.731 321.226C394.161 322.686 404.536 324.312 414.831 326.035C449.152 331.766 483.336 338.228 517.45 345.021C541.287 349.733 565.081 354.61 588.89 359.488"
                stroke="#171717"
                stroke-width="4.133"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M383.858 321.75C383.816 321.57 383.758 321.405 383.734 321.226C381.681 312.146 389.41 302.997 398.366 300.226C404.866 298.214 411.717 298.642 418.496 299.771C421.265 300.24 424.007 300.819 426.721 301.397C446.741 305.682 466.752 309.972 486.753 314.266C489.953 314.941 493.16 315.63 496.353 316.319C503.173 317.779 510.366 319.419 515.519 324.131C520.672 328.843 522.711 337.731 517.888 342.801"
                stroke="#171717"
                stroke-width="4.133"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M418.716 298.437C423.166 272.093 427.617 245.749 432.067 219.405C432.88 214.583 433.693 209.775 434.506 204.952C438.212 182.976 443.255 158.768 461.222 145.582C474.187 136.061 491.479 134.482 507.447 136.489C523.415 138.496 538.807 143.722 554.665 146.547C565.735 148.502 576.981 149.277 588.215 148.861C601.358 148.397 614.392 146.296 627.015 142.606C641.496 138.376 656.915 130.399 661.144 115.918C642.281 109.387 621.311 114.196 601.305 114.554C591.357 114.733 581.644 113.824 572.536 109.854"
                stroke="#171717"
                stroke-width="4.133"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M601.291 113.8C616.111 109.833 628.802 100.249 636.674 87.08C638.341 84.256 639.788 80.77 638.424 77.794C637.294 75.3 634.442 73.95 631.7 73.812C628.952 73.8574 626.235 74.3994 623.681 75.412C611.143 79.5453 598.6 83.6786 586.053 87.812C577.621 90.582 569.193 93.356 560.77 96.134"
                stroke="#171717"
                stroke-width="4.133"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M586.038 87.755C589.18 81.789 594.98 77.628 598.438 71.842C601.897 66.042 601.594 56.768 595.269 54.426C589.634 52.332 584.027 57.182 579.659 61.315C567.061 73.0668 552.161 82.076 535.902 87.7727C519.642 93.4694 502.378 95.7295 485.2 94.41C472.083 93.322 458.553 90.167 446 94.162C430.651 99.04 420.318 113.713 414.834 128.869C409.35 144.025 407.57 160.256 402.8 175.66C398.414 189.777 391.571 203.009 382.587 214.748C380.479 217.504 378.164 220.329 377.558 223.748C376.952 227.167 378.826 231.312 382.258 231.808C385.124 232.221 387.658 230.099 389.758 228.115C393.958 224.147 398.165 220.174 402.378 216.197C404.927 213.797 407.463 211.402 410.012 209.005"
                stroke="#171717"
                stroke-width="4.133"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M402.61 216.443C400.13 219.626 397.61 222.85 396.051 226.584C394.492 230.318 393.985 234.644 395.569 238.35C397.169 242.071 401.19 244.85 405.169 244.179C409.647 243.421 412.389 239.039 415.007 235.333C419.461 229.018 425.048 223.584 431.486 219.309"
                stroke="#171717"
                stroke-width="4.133"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M508.412 159.374C507.669 156.815 506.322 154.471 504.485 152.541C502.647 150.611 500.373 149.15 497.853 148.282C495.333 147.413 492.642 147.163 490.005 147.552C487.369 147.94 484.864 148.957 482.702 150.515C483.239 150.432 483.763 150.363 484.286 150.281"
                stroke="#171717"
                stroke-width="4.133"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M566.087 171.43C558.358 168.743 550.625 166.061 542.887 163.384C540.365 162.516 537.5 161.648 535.102 162.832C532.54 164.1 531.547 167.2 530.802 169.97C525.736 188.956 520.669 207.947 515.602 226.942C514.817 229.849 513.866 233.018 511.386 234.699C506.894 237.744 500.997 234.148 496.823 230.69"
                stroke="#171717"
                stroke-width="4.133"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M473.25 254.278C464.322 254.25 456.468 245.419 457.474 236.545"
                stroke="#171717"
                stroke-width="4.133"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M492.76 178.856C492.102 174.71 492.495 170.465 493.904 166.511"
                stroke="#171717"
                stroke-width="4.133"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M542.706 192.483C542.733 188.584 543.793 184.761 545.778 181.405"
                stroke="#171717"
                stroke-width="4.133"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M192.176 577.293L191.859 402.558L442.787 433.683L588.89 359.488L652.214 327.343L910.913 268.511L884.652 564.892"
                stroke="#171717"
                stroke-width="4.133"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M179.542 733.234L173.7 883.016L377.947 906.356L663.885 765.006L866.175 774.733L872.017 699.353"
                stroke="#171717"
                stroke-width="4.133"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M652.214 327.343L663.885 765.006"
                stroke="#171717"
                stroke-width="4.133"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M442.787 433.683L377.947 906.356"
                stroke="#171717"
                stroke-width="4.133"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M486.85 313.786C487.575 303.276 492.146 293.402 499.691 286.05C507.517 278.486 517.879 274.256 527.055 268.387C546.289 256.069 560.04 236.545 569.202 215.63C578.364 194.715 583.339 172.243 588.257 149.936"
                stroke="#171717"
                stroke-width="4.133"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M894.834 423.166C877.928 412.654 860.657 401.984 841.321 397.252C821.985 392.52 799.879 394.639 784.768 407.6C765.493 424.133 762.588 452.676 749.051 474.163C742.874 483.804 734.604 491.931 724.857 497.939C715.109 503.947 704.133 507.683 692.744 508.87C672.368 510.835 649.832 504.883 632.599 515.93C619.319 524.442 613.338 541.041 612.438 556.788C611.538 572.535 614.789 588.202 615.621 603.952C616.842 627.04 611.383 652.752 592.685 666.352C573.504 680.298 547.093 677.165 524.485 684.335C491.564 694.776 469.285 726.959 461.044 760.499C452.803 794.039 456.194 829.199 459.637 863.568"
                stroke="#171717"
                stroke-width="4.133"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M193.918 500.171C219.038 490.085 249.318 494.144 270.893 510.489C280.267 517.589 287.962 526.716 297.349 533.801C306.736 540.886 318.794 545.916 330.177 542.959C343.592 539.473 352.154 526.17 364.729 520.339C377.635 514.356 394.242 517.682 403.847 528.175C409.857 534.742 413.015 543.352 417.547 551.011C422.079 558.67 429.032 565.967 437.909 566.633C444.779 567.148 451.401 563.477 456.219 558.554C461.037 553.631 464.407 547.514 468.031 541.654C477.349 526.584 491.87 511.332 509.495 513.14C526.719 514.906 537.852 531.94 553.143 540.059C565.317 546.526 579.907 547.152 592.179 553.433C600.035 557.471 606.591 563.647 611.088 571.25"
                stroke="#171717"
                stroke-width="4.133"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M515.254 514.573C503.97 499.379 505.695 478.473 508.335 459.735C510.975 440.997 513.674 420.463 503.735 404.36"
                stroke="#171717"
                stroke-width="4.133"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M545.205 682.632C543.349 696.332 553.073 709.917 565.861 715.166C578.649 720.415 593.539 718.413 606.087 712.609C618.599 706.822 630.817 697.167 644.445 699.246C648.511 699.866 652.518 701.546 656.595 701C664.055 700 668.365 692.361 673.595 686.95C683.98 676.213 700.851 673.38 715.186 677.58C729.521 681.78 741.447 692.095 750.291 704.134C759.135 716.173 765.243 729.957 771.281 743.62C775.177 752.438 779.074 761.256 782.972 770.074"
                stroke="#171717"
                stroke-width="4.133"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M362.293 595.8L344.383 599.413C343.751 599.541 343.101 599.543 342.469 599.419C341.837 599.295 341.236 599.048 340.699 598.692C340.163 598.336 339.702 597.877 339.343 597.342C338.984 596.808 338.733 596.207 338.607 595.576L331.382 559.757C331.254 559.126 331.252 558.476 331.375 557.843C331.499 557.211 331.746 556.61 332.103 556.074C332.459 555.537 332.918 555.076 333.452 554.717C333.987 554.358 334.587 554.108 335.219 553.981L353.129 550.368C353.76 550.24 354.41 550.238 355.042 550.362C355.674 550.486 356.276 550.733 356.812 551.089C357.348 551.445 357.809 551.904 358.168 552.439C358.528 552.973 358.778 553.574 358.905 554.205L366.13 590.024C366.257 590.655 366.259 591.305 366.136 591.937C366.012 592.57 365.765 593.171 365.408 593.707C365.052 594.244 364.593 594.705 364.059 595.064C363.524 595.423 362.924 595.673 362.293 595.8V595.8Z"
                fill="#171717"
              />
              <path
                d="M361.315 515.055L353.915 518.93C353.344 519.229 352.721 519.413 352.079 519.471C351.438 519.529 350.791 519.46 350.176 519.267C349.561 519.075 348.991 518.764 348.496 518.35C348.002 517.937 347.594 517.431 347.296 516.86L337.941 498.992C337.642 498.422 337.458 497.798 337.4 497.156C337.342 496.515 337.411 495.868 337.603 495.254C337.795 494.639 338.107 494.068 338.52 493.574C338.933 493.079 339.439 492.671 340.01 492.373L347.41 488.498C347.98 488.199 348.604 488.015 349.246 487.957C349.887 487.899 350.534 487.968 351.149 488.161C351.763 488.353 352.334 488.664 352.828 489.078C353.323 489.491 353.731 489.997 354.029 490.568L363.385 508.436C363.684 509.006 363.868 509.63 363.926 510.272C363.984 510.913 363.914 511.56 363.722 512.175C363.53 512.789 363.218 513.36 362.805 513.854C362.392 514.349 361.886 514.757 361.315 515.055V515.055Z"
                fill="#171717"
              />
              <path
                d="M337.261 530.181L332.961 532.211C332.379 532.486 331.748 532.644 331.104 532.675C330.461 532.706 329.818 532.61 329.211 532.392C328.605 532.175 328.048 531.84 327.571 531.406C327.095 530.973 326.708 530.45 326.434 529.867L321.08 518.511C320.805 517.929 320.647 517.298 320.616 516.654C320.585 516.011 320.681 515.368 320.899 514.761C321.116 514.155 321.452 513.598 321.885 513.121C322.318 512.645 322.841 512.258 323.424 511.984L327.724 509.955C328.306 509.68 328.937 509.522 329.581 509.491C330.224 509.46 330.867 509.556 331.473 509.773C332.079 509.991 332.637 510.326 333.113 510.759C333.59 511.192 333.977 511.715 334.251 512.298L339.605 523.654C339.88 524.236 340.038 524.867 340.069 525.511C340.1 526.154 340.004 526.797 339.786 527.404C339.569 528.01 339.233 528.567 338.8 529.044C338.367 529.52 337.844 529.907 337.261 530.181V530.181Z"
                fill="#171717"
              />
              <path
                d="M760.684 414.026L755.26 429.467C754.796 430.789 753.825 431.872 752.562 432.479C751.299 433.085 749.846 433.165 748.524 432.701L719.472 422.5C718.818 422.27 718.215 421.913 717.698 421.45C717.181 420.987 716.761 420.427 716.461 419.802C716.16 419.176 715.986 418.498 715.948 417.805C715.91 417.112 716.009 416.419 716.239 415.764L721.663 400.323C722.128 399.001 723.098 397.918 724.362 397.311C725.625 396.705 727.077 396.625 728.399 397.089L757.451 407.295C758.772 407.759 759.855 408.729 760.461 409.991C761.067 411.253 761.148 412.705 760.684 414.026V414.026Z"
                fill="#171717"
              />
              <path
                d="M773.41 391.019L771.469 396.547C771.004 397.869 770.033 398.952 768.77 399.559C767.507 400.165 766.055 400.245 764.733 399.781L750.906 394.924C749.584 394.46 748.5 393.489 747.894 392.226C747.287 390.963 747.207 389.51 747.672 388.188L749.613 382.66C750.077 381.338 751.048 380.255 752.311 379.648C753.574 379.042 755.026 378.962 756.349 379.426L770.177 384.283C771.498 384.748 772.582 385.718 773.188 386.981C773.795 388.245 773.874 389.697 773.41 391.019V391.019Z"
                fill="#171717"
              />
              <path
                d="M742.676 638.152L755.145 644.577C756.391 645.219 757.331 646.329 757.758 647.664C758.185 648.999 758.065 650.449 757.423 651.695L745.437 674.955C744.795 676.201 743.685 677.14 742.35 677.568C741.016 677.995 739.566 677.874 738.32 677.233L725.85 670.808C724.604 670.166 723.665 669.055 723.238 667.721C722.811 666.386 722.931 664.936 723.573 663.69L735.558 640.43C736.2 639.184 737.311 638.245 738.645 637.817C739.98 637.39 741.43 637.511 742.676 638.152V638.152Z"
                fill="#171717"
              />
              <path
                d="M708.06 642.332L718.773 646.12C719.58 646.405 720.24 647 720.609 647.772C720.978 648.544 721.025 649.431 720.739 650.238L715.704 664.478C715.563 664.878 715.345 665.245 715.061 665.56C714.778 665.875 714.435 666.132 714.053 666.314C713.67 666.497 713.256 666.602 712.832 666.624C712.409 666.647 711.986 666.585 711.586 666.444L700.873 662.657C700.066 662.371 699.406 661.777 699.037 661.005C698.669 660.232 698.622 659.345 698.907 658.538L703.942 644.299C704.228 643.492 704.822 642.832 705.594 642.463C706.366 642.095 707.253 642.047 708.06 642.332V642.332Z"
                fill="#171717"
              />
              <path
                d="M452.509 732.583C452.509 732.583 474.554 684.602 491.409 677.471C508.264 670.34 566.621 670.339 580.238 658.671C593.855 647.003 600.338 616.526 600.987 602.909C601.636 589.292 589.964 565.303 579.587 562.709C569.21 560.115 539.387 552.983 534.848 547.796C530.309 542.609 519.287 529.642 505.671 530.938C492.055 532.234 476.5 555.574 476.5 555.574C476.5 555.574 451.212 575.026 448.619 587.993C446.026 600.96 426.574 735.824 426.574 735.824C426.574 735.824 417.497 771.485 432.409 769.541C447.321 767.597 452.509 732.583 452.509 732.583Z"
                fill="url(#paint2_linear_46_7743)"
              />
              <path
                d="M739.744 511.486C741.859 510.486 768.273 493.979 775.404 479.067C782.535 464.155 777.998 440.167 788.372 433.031C798.746 425.895 821.44 415.525 835.056 420.063C848.672 424.601 863.585 441.463 856.456 463.505C849.327 485.547 850.639 512.805 827.279 534.827C804.585 556.227 750.77 576.972 729.373 575.675C707.976 574.378 684.358 559.161 683.986 543.904C683.335 517.321 717.701 521.859 739.744 511.486Z"
                fill="url(#paint3_linear_46_7743)"
              />
              <path
                d="M308.568 769.542C308.568 769.542 273.555 759.168 265.775 786.399C257.995 813.63 250.633 835.768 256.049 851.238C260.8 864.805 281.336 879.767 305.974 879.767C330.612 879.767 358.494 849.941 362.383 831.786C366.272 813.631 367.571 777.97 355.899 774.08C344.227 770.19 308.568 769.542 308.568 769.542Z"
                fill="url(#paint4_linear_46_7743)"
              />
              <path
                d="M480.956 387.032C478.806 382.271 476.657 377.511 474.508 372.752"
                stroke="#171717"
                stroke-width="4.133"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M468.741 384.44C474.381 381.24 480.022 378.037 485.664 374.831"
                stroke="#171717"
                stroke-width="4.133"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M290.111 356.007L283.164 340.364"
                stroke="#171717"
                stroke-width="4.133"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M276.075 353.8C282.164 350.188 288.252 346.575 294.34 342.962"
                stroke="#171717"
                stroke-width="4.133"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M383.043 409.733C380.457 404.326 377.871 398.92 375.284 393.513"
                stroke="#171717"
                stroke-width="4.133"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M369.566 409.11C375.402 405.003 381.235 400.895 387.066 396.787"
                stroke="#171717"
                stroke-width="4.133"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M161.513 480.26L148.972 464.88"
                stroke="#171717"
                stroke-width="4.133"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M146.479 481.666L163.337 464.808"
                stroke="#171717"
                stroke-width="4.133"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M125.592 601.735C122.129 598.068 118.667 594.398 115.206 590.724"
                stroke="#171717"
                stroke-width="4.133"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M113.274 603.448C117.601 598.264 121.928 593.08 126.255 587.896"
                stroke="#171717"
                stroke-width="4.133"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M170.276 555.055L161.033 541.555"
                stroke="#171717"
                stroke-width="4.133"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M101.726 520.554L114.044 506.937"
                stroke="#171717"
                stroke-width="4.133"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M173.701 431.086C171.877 426.753 168.975 422.958 165.271 420.063"
                stroke="#171717"
                stroke-width="4.133"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M188.515 373.272L201.487 360.957"
                stroke="#171717"
                stroke-width="4.133"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M277.774 395C275.293 391.463 272.813 387.926 270.333 384.388"
                stroke="#171717"
                stroke-width="4.133"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M348.2 352.7C351.874 348.594 355.549 344.488 359.225 340.383"
                stroke="#171717"
                stroke-width="4.133"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M340.116 399.528L331.874 390.921"
                stroke="#171717"
                stroke-width="4.133"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M417.5 370.786L426.577 359.114"
                stroke="#171717"
                stroke-width="4.133"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M438.893 409.69C436.731 407.097 434.57 404.503 432.409 401.909"
                stroke="#171717"
                stroke-width="4.133"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M518.601 373.329C521.195 370.953 523.789 368.576 526.383 366.199"
                stroke="#171717"
                stroke-width="4.133"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M498.926 340.245L504.146 319.505"
                stroke="#171717"
                stroke-width="4.133"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M474.513 336.411C476.467 329.064 478.422 321.718 480.377 314.373"
                stroke="#171717"
                stroke-width="4.133"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M444.629 331.211C446.408 323.874 448.187 316.538 449.967 309.202"
                stroke="#171717"
                stroke-width="4.133"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M419.376 326.679C421.29 319.107 423.203 311.535 425.116 303.962"
                stroke="#171717"
                stroke-width="4.133"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M397.842 322.11L402.491 302.036"
                stroke="#171717"
                stroke-width="4.133"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M160.187 616.954C154.694 612.111 146.21 611.814 139.498 614.742C132.786 617.67 127.607 623.3 123.457 629.33C105.029 656.117 104.785 694.174 122.869 721.196L126.369 718.32"
                stroke="#171717"
                stroke-width="4.133"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M914.032 433.376L920.532 372.076"
                stroke="#171717"
                stroke-width="4.133"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M56.4753 684.926C43.8516 667.24 38.5246 645.371 41.6003 623.861"
                stroke="#171717"
                stroke-width="4.133"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M510.43 869.435C537.609 853.562 565.234 838.489 593.304 824.215"
                stroke="#171717"
                stroke-width="4.133"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <g opacity="0.1">
                <path
                  d="M523.418 141.879C520.188 137.497 512.985 137.324 507.985 136.661C501.499 135.813 494.945 135.605 488.418 136.039C475.175 136.926 462.431 141.211 452.999 150.925C443.482 160.725 438.083 174.032 434.717 187.084C430.591 203.084 427.446 219.373 424.935 235.697C423.489 245.09 422.263 254.515 421.257 263.974C420.264 273.385 418.85 283.166 419.185 292.634C419.211 294.956 420.071 297.192 421.608 298.933C423.145 300.674 425.257 301.805 427.558 302.118C431.82 302.625 437.458 300.011 438.158 295.201C439.55 285.509 439.758 275.629 440.751 265.88C441.699 256.583 442.905 247.32 444.368 238.089C447.252 219.925 451.091 201.926 455.868 184.166C459.618 170.25 465.757 155.787 478.713 148.219C485.696 144.253 493.626 142.26 501.655 142.456C505.604 142.49 509.547 142.759 513.463 143.262C516.848 143.699 519.936 144.635 523.121 143.033C523.313 142.919 523.452 142.734 523.508 142.518C523.565 142.302 523.533 142.072 523.421 141.879H523.418Z"
                  fill="#171717"
                />
              </g>
              <g opacity="0.1">
                <path
                  d="M404.855 299.824C403.616 299.876 402.633 299.098 401.378 299.048C400.403 299.071 399.438 299.241 398.515 299.554C396.259 300.343 394.11 301.411 392.12 302.734C390.12 303.977 387.929 305.027 386.42 306.867C384.353 309.153 382.827 311.875 381.956 314.831C379.347 325.366 395.439 329.831 398.228 319.317C398.928 316.69 398.867 316.198 399.595 313.517C399.899 312.755 400.041 311.937 400.012 311.117C400.026 310.202 400.01 310.079 399.964 310.749C399.843 311.442 399.981 311.317 400.38 310.376C400.688 309.672 400.981 308.962 401.259 308.247L399.873 310.626C400.948 309.338 402.105 308.122 403.339 306.985C404.254 306.109 405.046 304.147 405.899 303.671C406.279 303.435 406.573 303.083 406.737 302.667C406.9 302.251 406.926 301.794 406.809 301.362C406.692 300.93 406.439 300.548 406.088 300.272C405.736 299.995 405.305 299.84 404.858 299.828L404.855 299.824Z"
                  fill="#171717"
                />
              </g>
              <g opacity="0.1">
                <path
                  d="M380.778 321.208C369.027 318.387 356.964 319.143 345.05 317.385C333.306 315.652 321.872 313.796 309.935 313.685C287.032 313.505 264.187 316.011 241.867 321.149C200.105 330.76 162.742 351.803 134.448 384.165C106.717 415.882 87.4001 454.664 75.3001 494.847C62.5005 537.469 58.2911 582.209 62.9161 626.471C65.4061 649.985 68.9981 675.557 82.6651 695.534C96.2781 715.434 119.045 728.39 143.477 723.084C149.491 721.778 152.999 714.77 151.433 709.072C149.716 702.826 143.462 699.851 137.421 701.116C122.149 704.316 106.941 692.955 99.3471 680.066C90.1111 664.391 87.2001 645.179 85.2201 627.357C80.7484 586.879 83.8647 545.922 94.4091 506.586C104.209 469.971 120.235 433.713 144.009 403.938C168.142 373.715 199.396 352.365 236.56 341.452C259.16 334.816 282.578 331.766 306.039 330.342C318.475 329.587 330.748 328.197 343.098 326.706C355.624 325.194 368.264 327.343 380.778 325.638C383.078 325.324 382.848 321.705 380.778 321.208V321.208Z"
                  fill="#171717"
                />
              </g>
            </g>
          </g>
          <defs>
            <linearGradient
              id="paint0_linear_46_7743"
              x1="326.276"
              y1="315.536"
              x2="326.276"
              y2="724.129"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#4A9FFF" />
              <stop
                offset="1"
                stop-color="#2A67F7"
              />
            </linearGradient>
            <linearGradient
              id="paint1_linear_46_7743"
              x1="452.012"
              y1="298.821"
              x2="452.012"
              y2="345.021"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#4A9FFF" />
              <stop
                offset="1"
                stop-color="#2A67F7"
              />
            </linearGradient>
            <linearGradient
              id="paint2_linear_46_7743"
              x1="512.425"
              y1="530.847"
              x2="512.425"
              y2="769.618"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#4A9FFF" />
              <stop
                offset="1"
                stop-color="#2A67F7"
              />
            </linearGradient>
            <linearGradient
              id="paint3_linear_46_7743"
              x1="771.138"
              y1="418.952"
              x2="771.138"
              y2="575.733"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#4A9FFF" />
              <stop
                offset="1"
                stop-color="#2A67F7"
              />
            </linearGradient>
            <linearGradient
              id="paint4_linear_46_7743"
              x1="309.666"
              y1="767.602"
              x2="309.666"
              y2="879.767"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#4A9FFF" />
              <stop
                offset="1"
                stop-color="#2A67F7"
              />
            </linearGradient>
            <clipPath id="clip0_46_7743">
              <rect
                width="960"
                height="960"
                fill="white"
              />
            </clipPath>
            <clipPath id="clip1_46_7743">
              <rect
                width="885"
                height="858"
                fill="white"
                transform="translate(38 51)"
              />
            </clipPath>
          </defs>
        </svg>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts"></script>
